<template lang='pug'>
v-card(xs12).card-style
  v-snackbar(:value='contactsStatusError', color='error')
    div {{ contactsStatusErrorMessage }}
  v-flex
    v-flex.centered.title-style CONTACT STATUS
    v-flex.centered Current status of your Leads+ contacts assigned by Qualify.
  v-flex.centered
    canvas.chart(id="contact-status-chart" width="1000" height="1000" ref="canvas")
    v-flex.pa-0.ma-0.loadingDialog(v-if="contactsStatusInProgress") Loading...
</template>
      
<script>
import { createNamespacedHelpers } from 'vuex';
import Chart from 'chart.js/auto';

const { mapGetters: mapQualifyGetters } = createNamespacedHelpers('qualify');
const { mapGetters: mapLeadsplusGetters } = createNamespacedHelpers('leadsplus');
const { mapActions: mapReportingActions, mapState: mapReportingState } = createNamespacedHelpers('reportingQualify');
let chart;

export default {
  name: 'ContactsStatusWidget',
  data() {
    return {
      graphData: [1],
      graphLabels: ['No Data'],
      graphColors: ['rgb(35,94,161)', 'rgb(99,144,216)', 'rgb(82,158,235)', 'rgb(202,229,255)', 'rgb(255,154,0)', 'rgb(243,189,43)'],
      graphTotal: 1,
    }
  },
  computed: {
    ...mapQualifyGetters(['isIntegrationConnected']),
    ...mapLeadsplusGetters({ isLeadsplusIntegrationConnected: 'isIntegrationConnected' }),
    ...mapReportingState(['contactsStatusTotal', 'contactsStatusNames', 'contactsStatusCounts', 'contactsStatusInProgress', 'contactsStatusError', 'contactsStatusErrorMessage']),
    watchedValue() {
      return `${this.graphData}|${this.graphLabels}`;
    }
  },
  created() {
    this.getWidgetData();
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    watchedValue: {
      handler() {
        this.renderChart();
      }
    },
    isLeadsplusIntegrationConnected: {
      handler() {
        this.renderChart();
      }
    }
  },
  methods: {
    ...mapReportingActions(['getContactsStatusQualify']),
    async getWidgetData() {
      if (!this.isLeadsplusIntegrationConnected) {
        this.loadMockData();
        return;
      }

      if (!this.isIntegrationConnected || this.contactsStatusInProgress) {
        this.loadEmptyData();
        return;
      }

      const querySettings = { leadsource: 'leadsplus' };
      await this.getContactsStatusQualify(querySettings);
      this.loadRealData();
    },
    loadMockData() {
      this.graphLabels = ['Follow Up Now', 'Qualifying', 'Follow Up Later', 'Not Interested', 'Unresponsive', 'Just Curious'];
      this.graphData = [20, 60, 5, 5, 5, 5];
      this.graphTotal = 100;
    },
    loadRealData() {
      this.graphLabels = this.contactsStatusNames;
      this.graphTotal = this.contactsStatusTotal;
      this.graphData = this.contactsStatusCounts;
    },
    loadEmptyData() {
      this.graphLabels = ['No Data'];
      this.graphTotal = 1;
      this.graphData = [1];
    },
    formatData() {
      var combined = [];
      for (var i = 0; i < this.graphLabels.length; i++) {
        combined.push({ 'label': this.graphLabels[i], 'data': this.graphData[i] });
      }
      combined.sort(function (a, b) {
        return b.data - a.data;
      });
      var formattedLabels = [];
      var formattedData = [];
      var formattedColor = [];
      for (var i = 0; i < combined.length; i++) {
        var percentage = Number(combined[i].data / this.graphTotal).toLocaleString(undefined, { style: 'percent', maximumFractionDigits: 0 })
        formattedLabels.push(percentage + ' ' + combined[i].label);
        formattedData.push(combined[i].data);
        formattedColor.push(combined[i].data > 0 ? this.graphColors[i] : 'rgb(165,165,165)')
      }
      return { 'labels': formattedLabels, 'data': formattedData, 'colors': formattedColor }

    },
    async renderChart() {

      await this.getWidgetData();
      var formatted = await this.formatData();
      var flabels = formatted.labels;
      var fdata = formatted.data;
      var fcolors = formatted.colors;

      var dataset = {
        data: fdata,
        backgroundColor: fcolors
      }

      if (chart !== undefined) chart.destroy();

      chart = new Chart(document.getElementById('contact-status-chart').getContext('2d'), {
        type: 'pie',
        data: {
          labels: flabels,
          datasets: [dataset],
        },
        options: {
          plugins: {
            legend: {
              position: 'right',
              labels: {
                boxWidth: 15,
              },
            },
          },
        },
      });
    },
  },
}
</script>
    
<style lang="scss" scoped>
.card-style {
  padding: 15px;
  height: 100%;
}

.centered {
  display: flex;
  justify-content: center;
}

.title-style {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
}

.chart {
  max-height: 350px;
}

.loadingDialog {
  position: absolute;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  font-weight: bold;
  font-size: 16px;
}
</style>
